import React, {useMemo, useState} from "react";
import { ModalNames } from "../../../Constants/modalNames";
import { Div, Icon, Text } from "../../Kit";
import { useLanguage } from "../../../Store/modules/language";
import { Button } from "../../Kit/Button";
import { useModal } from "../../../Store/modules/modal/modal";
import { Trans } from "react-i18next";
import i18n from "i18next";
import { separate } from "../../../Utils";
import { Add } from "iconsax-react";
import settings from "../../../settings/settings";
import { useTheme } from "../../../Store/modules/theme";
import { useChoosePurchaseModel } from "../../../Store/modules/ai/choosePurchaseModel/choosePurchaseModel";
import { useBuySubscriptionPlan } from "../../../Store/modules/ai/buySubscriptionPlan/buySubscriptionPlan";
import {Modal} from "../Modal/Modal";
import {ToggleSwitch} from "../ToggleSwitch/ToggleSwitch";

export const BuySubscriptionModal: React.FC = () => {
    const { direction } = useLanguage();
    const { modalProps, dispatchCloseModal } = useModal();
    const { name: theme } = useTheme();
    const { title, price, type , walletBalance ,plan_id,token_id,discount_code} = modalProps || {};
    const { choosePurchaseModelLoading } = useChoosePurchaseModel();
    const { buySubscriptionPlanLoading , dispatchBuySubscriptionPlan } = useBuySubscriptionPlan();
    const [useWallet, setUseWallet] = useState<boolean>(false);
    const loading = useMemo(() => {
        if (type === "purchaseModel") {
            return choosePurchaseModelLoading;
        }
        if (type === "subscription") {
            return buySubscriptionPlanLoading;
        }
        return false;
    }, [buySubscriptionPlanLoading, choosePurchaseModelLoading, type]);

    const onConfirm = () => {
        dispatchBuySubscriptionPlan({
            plan_id,
            token_id,
            discount_code,
            use_wallet: isNeg ? true : useWallet,
        })
    };
    const nb = Number(walletBalance);
    const isNeg = !Number.isNaN(nb) && nb < 0;

    const numericPrice = Number(price) || 0;
    const numericWalletBalance = Number(walletBalance) || 0;

    const finalPayment = isNeg
        ? numericPrice + Math.abs(numericWalletBalance)
        : useWallet
            ? Math.max(numericPrice - numericWalletBalance, 0)
            : numericPrice;

    return (
        <Modal
            modalName={ModalNames.BuySubscriptionModal}
            ignorePadding="w-full py-[15px] px-[20px]"
            modalClassName="rounded-[10px] relative w-[327px] flex flex-col justify-between items-center"
        >
            <Div
                bg="forthOpt"
                className="w-[27px] h-[27px] flex items-center justify-center pointer rounded-[50%] absolute right-[10px] top-[10px] "
                onClick={() => dispatchCloseModal()}
            >
                <Icon
                    Component={Add}
                    size={20}
                    className="rotate-[45deg]"
                    color="text"
                />
            </Div>
            <div dir={direction} className="flex justify-center pt-[10px]">
                <img src={settings.logo?.[theme]} alt="logo" className="w-[60px]" />
            </div>
            <div className="py-5 text-center">
                {modalProps.title ? (
                    <Trans
                        i18nKey="buySubscriptionModal.details"
                        className="text-center"
                        i18n={i18n}
                        dir={direction}
                        values={{
                            title
                        }}
                        components={{
                            Title: <Text elementType="p" fontWeight={500} />,
                            Text: (
                                <Text
                                    elementType="p"
                                    fontWeight={400}
                                    translatable={false}
                                    lineHeight={1.9}
                                />
                            ),
                        }}
                    />
                ) : null}
            </div>
            <div className="flex justify-between mt-6">
                <Text elementType="span" fontSize={14}>tokenCost</Text>
                <div>
                    <Text elementType="span" translatable={false} fontSize={14}>{separate(price)}</Text>
                    <Text elementType="span" className="ms-1" fontSize={12}>toman</Text>
                </div>
            </div>
            <div className="flex justify-between items-center mt-6">
                <Text elementType="span" translatable={false} fontSize={14}>
                    <Trans
                        i18nKey="walletBalance"
                        values={{
                            amount: Number(Math.floor(Number(walletBalance ?? 0))).toLocaleString("en-US"),
                        }}
                        components={{
                            Text: <Text elementType="span" color={isNeg ? "error" : "success"} />,
                        }}
                    />
                </Text>
                <ToggleSwitch
                    label=""
                    description=""
                    checked={useWallet || isNeg}
                    onChange={() => {
                        if (!isNeg) {
                            setUseWallet(!useWallet);
                        }
                    }}
                />
            </div>
            <Div border className="mt-8"/>
            <div className="flex justify-between items-center mt-6 mb-3">
                <Text elementType="span" translatable={false} fontSize={16}>
                    <Trans
                        i18nKey="finalPaymentGateway"
                        components={{
                            Text: <Text elementType="span" className="text-[13px]" />,
                        }}
                    />
                </Text>
                <div>
                    <Text elementType="span" translatable={false} fontSize={15} fontWeight={600}>{Number(Math.floor(Number(finalPayment ?? 0))).toLocaleString("en-US")}</Text>
                    <Text elementType="span" className="ms-1" fontSize={12}>toman</Text>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center">
                <Button
                    title="confirmationModal.confirmPayment"
                    className="w-full h-[45px] mt-[14px]"
                    textClassName="text-sm"
                    loading={loading}
                    bg="primary"
                    onClick={onConfirm}
                />
            </div>
        </Modal>
    );
};